import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import workerImg from '../../media/worker.png';
import useTranslations from './translation/hooks/translation';
import { useThemeContext } from './ThemeContext';

interface Props {
  percentAmount: string;
}

export const JobModal: React.FC<Props> = ({ percentAmount }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  const { currentLanguage } = useTranslations();

  const title = currentLanguage === 'pl' ? 'Szukasz pracy z końmi?' : 'Looking for a job with horses?';
  const desc = currentLanguage === 'pl' ? 'Aplikuj do naszego zespołu, a skontaktujemy się z Tobą.' : 'Apply to join our team and we will contact you.';
  const button = currentLanguage === 'pl' ? 'Aplikuj teraz' : 'Apply now';

  return (
    <div>
      <div style={{ position: 'relative', paddingTop: percentAmount, margin: '16px', cursor: 'pointer' }} onClick={handleOpen}>
        <img style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'scale-down' }} src={workerImg} alt="Job opportunity" />
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-labelledby="job-modal-title"
        aria-describedby="job-modal-description"
        PaperProps={{
          sx: {
            bgcolor: darkMode ? '#232323' : '#FFFFFF',
            border: `1px solid ${darkMode ? '#333333' : '#EEEEEE'}`,
            borderRadius: '8px',
            color: darkMode ? '#FFFFFF' : '#000000',
            boxShadow: darkMode ? '0 8px 16px rgba(0, 0, 0, 0.3)' : '0 8px 16px rgba(0, 0, 0, 0.12)',
            pb: 1,
          },
        }}
      >
        <DialogTitle id="job-modal-title" sx={{ fontWeight: 400, color: darkMode ? '#FFFFFF' : '#000000' }}>
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="job-modal-description" sx={{ color: darkMode ? '#CCCCCC' : '#555555', lineHeight: 1.7 }}>
            {desc}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              fontWeight: 600,
              textTransform: 'none',
              mx: 1.5,
              borderRadius: '4px',
              boxShadow: 'none',
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                transform: 'translateY(-2px)',
              },
            }}
            size="large"
            variant="contained"
            fullWidth
            onClick={() => window.open('https://wa.me/+48729883891')}
          >
            {button}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
